<template>
    <div style="position: fixed; top: 0rem; left: 0rem; width: 100vw; height: 100vh; background-color: #0D0D0D; opacity: 0.3; z-index: 999999;"></div>
</template>

<script>
export default {
    name: "blur"
}
</script>

<style scoped>

</style>
